(function () {
  window.__easifyAddOnsDebug = function () {
    return { error: 'easify-add-ons-conditional.js not initialized' };
  };

  var scriptEl = document.querySelector(
    'script[src*="easify-add-ons-conditional"][data-easify-dimension-option-id]'
  );
  var productPage = document.querySelector('product-page[data-easify-dimension-option-id]');
  var configEl = scriptEl || productPage;

  if (!configEl) return;

  var DIM_ID = configEl.getAttribute('data-easify-dimension-option-id');
  var ADDONS_ID = configEl.getAttribute('data-easify-addons-option-id');
  var WIDTH_MIN = parseFloat(configEl.getAttribute('data-easify-width-min') || '1000');
  var WIDTH_LABEL = (configEl.getAttribute('data-easify-width-label') || 'Breite').toLowerCase();
  var HEIGHT_LABEL = (
    (scriptEl && scriptEl.getAttribute('data-easify-height-label')) ||
    configEl.getAttribute('data-easify-height-label') ||
    'Höhe'
  ).toLowerCase();
  var VISIBLE_CLASS = 'easify-addons-visible-by-width';
  var HINT_CLASS = 'easify-dimension-cm';
  var INPUT_SELECTOR = 'input[type="number"], input[type="text"], input[inputmode="decimal"], input[inputmode="numeric"]';
  var MAX_BOOTSTRAP_ATTEMPTS = 40;
  var MAX_UNCHECK_ATTEMPTS = 3;
  var UNCHECK_VERIFY_MS = 180;

  var pollId = null;
  var observer = null;
  var bootstrapAttempts = 0;
  var isBootstrapped = false;
  var hintMap = new WeakMap();
  var boundInputs = new WeakSet();
  var visibilitySequence = 0;

  if (!DIM_ID || !ADDONS_ID) return;

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function getDimensionEl() {
    return document.querySelector('[data-option-id="' + DIM_ID + '"]');
  }

  function getAddOnsEl() {
    return document.querySelector('[data-option-id="' + ADDONS_ID + '"]');
  }

  function getObserveRoot() {
    return document.querySelector('.product-text') || document.querySelector('product-page') || document.body;
  }

  function findDimensionInput(dimensionEl, label) {
    if (!dimensionEl) return null;

    var labels = dimensionEl.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim().toLowerCase().indexOf(label) === -1) continue;

      var container =
        labels[i].closest('[class*="dimension"]') ||
        labels[i].closest('div') ||
        labels[i].parentElement;
      var input = container && container.querySelector(INPUT_SELECTOR);
      if (input) return input;
    }

    if (label === WIDTH_LABEL) {
      var inputs = dimensionEl.querySelectorAll(INPUT_SELECTOR);
      return inputs.length ? inputs[0] : null;
    }

    return null;
  }

  function findWidthInput(dimensionEl) {
    return findDimensionInput(dimensionEl, WIDTH_LABEL);
  }

  function findHeightInput(dimensionEl) {
    return findDimensionInput(dimensionEl, HEIGHT_LABEL);
  }

  function getNumericValue(input) {
    if (!input || input.value === '') return null;
    var value = parseFloat(String(input.value).replace(',', '.'));
    return Number.isFinite(value) ? value : null;
  }

  function formatCm(mm) {
    return (mm / 10).toLocaleString('de-DE', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });
  }

  function parseMoney(value) {
    var text = String(value || '').replace(/\u00a0/g, ' ');
    var matches = text.match(/-?\d[\d.\s]*(?:,\d{1,2}|\.\d{1,2})/g);
    if (!matches || !matches.length) return null;

    var raw = matches[0].replace(/\s/g, '');
    if (raw.indexOf(',') !== -1) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    }

    var parsed = parseFloat(raw.replace(/[^\d.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function parseTrailingMoney(value) {
    var text = String(value || '');
    var parentheticalMatches = text.match(/\([^()]*\)\s*$/);
    if (parentheticalMatches && parentheticalMatches[0]) {
      var parsedParenthetical = parseMoney(parentheticalMatches[0]);
      if (parsedParenthetical !== null) return parsedParenthetical;
    }

    var moneyMatches = text.match(/€\s*-?\d[\d.\s]*(?:,\d{1,2}|\.\d{1,2})|-?\d[\d.\s]*(?:,\d{1,2}|\.\d{1,2})\s*€/g);
    if (!moneyMatches || !moneyMatches.length) return null;
    return parseMoney(moneyMatches[moneyMatches.length - 1]);
  }

  function formatMoney(amount) {
    return '€' + amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getProductBasePrice() {
    var priceRoot = document.querySelector('.main-product-price .product-price') ||
      document.querySelector('[data-update-block="price-compact-main"] .product-price');
    if (!priceRoot) return null;

    var priceEl = priceRoot.querySelector('.product-price--original') || priceRoot;
    return parseMoney(priceEl.textContent);
  }

  function getDimensionPriceSuffix(dimensionEl) {
    if (!dimensionEl) return null;
    return dimensionEl.querySelector('.po-label-suffix span') || dimensionEl.querySelector('.po-label-suffix');
  }

  function getDimensionAddOnPrice(dimensionEl, suffixEl) {
    if (!dimensionEl) return null;

    var propertyInput = qsa('input[type="hidden"]', dimensionEl).find(function (input) {
      return String(input.name || '').indexOf('properties[') !== -1 && parseTrailingMoney(input.value) !== null;
    });

    if (propertyInput) {
      return parseTrailingMoney(propertyInput.value);
    }

    if (suffixEl && suffixEl.dataset.easifyDimensionAddonPrice) {
      var stored = parseFloat(suffixEl.dataset.easifyDimensionAddonPrice);
      if (Number.isFinite(stored)) return stored;
    }

    if (suffixEl && suffixEl.dataset.easifyDimensionDisplayPrice !== 'base-included') {
      return parseTrailingMoney(suffixEl.textContent);
    }

    return null;
  }

  function updateDimensionPriceDisplay() {
    var dimensionEl = getDimensionEl();
    var suffixEl = getDimensionPriceSuffix(dimensionEl);
    if (!dimensionEl || !suffixEl) return;

    var basePrice = getProductBasePrice();
    var addOnPrice = getDimensionAddOnPrice(dimensionEl, suffixEl);

    if (basePrice === null || addOnPrice === null) return;

    suffixEl.dataset.easifyDimensionAddonPrice = String(addOnPrice);
    suffixEl.dataset.easifyDimensionDisplayPrice = 'base-included';

    var displayText = '(' + formatMoney(basePrice + addOnPrice) + ')';
    if (suffixEl.textContent.trim() !== displayText) {
      suffixEl.textContent = displayText;
    }
  }

  function getFieldWrapper(input) {
    if (!input || !input.parentElement) return input;
    return input.parentElement;
  }

  function ensureHint(input) {
    if (!input) return null;

    var anchor = getFieldWrapper(input);
    var hint = hintMap.get(input);

    if (hint) {
      if (hint.previousElementSibling !== anchor) {
        anchor.insertAdjacentElement('afterend', hint);
      }
      return hint;
    }

    hint = document.createElement('span');
    hint.className = HINT_CLASS;
    hint.setAttribute('hidden', 'hidden');
    hint.setAttribute('aria-live', 'polite');
    anchor.insertAdjacentElement('afterend', hint);
    hintMap.set(input, hint);
    return hint;
  }

  function updateHint(input) {
    if (!input) return;

    var hint = ensureHint(input);
    var value = getNumericValue(input);

    if (value === null) {
      hint.setAttribute('hidden', 'hidden');
      hint.textContent = '';
      return;
    }

    hint.textContent = '= ' + formatCm(value) + ' cm';
    hint.removeAttribute('hidden');
  }

  function getCheckboxLabel(checkbox) {
    var label = checkbox && checkbox.closest('label');
    var labelText = label && label.querySelector('.po-optionItemLabel-label');
    return normalize(labelText ? labelText.textContent : label && label.textContent);
  }

  function getOptionsRoot(addOnsEl) {
    return addOnsEl.closest('.po-productPageOptions-root') ||
      addOnsEl.closest('form') ||
      addOnsEl.parentElement ||
      document;
  }

  function isStoredAsSelected(checkbox, addOnsEl) {
    var optionLabel = getCheckboxLabel(checkbox);
    if (!optionLabel) return !!checkbox.checked;

    return qsa('input[type="hidden"]', getOptionsRoot(addOnsEl)).some(function (hiddenInput) {
      var name = String(hiddenInput.name || '');
      if (name.indexOf('properties[') === -1) return false;
      return normalize(hiddenInput.value).indexOf(optionLabel) !== -1;
    });
  }

  function needsRealUncheck(checkbox, addOnsEl) {
    return !!checkbox.checked || isStoredAsSelected(checkbox, addOnsEl);
  }

  function performRealClick(checkbox) {
    if (!checkbox) return;

    if (checkbox.disabled) {
      checkbox.disabled = false;
    }

    var clickable = checkbox.closest('label') || checkbox;
    clickable.click();
  }

  function disableCheckbox(checkbox) {
    if (!checkbox || checkbox.disabled) return;
    checkbox.dataset.easifyDisabledByWidth = 'true';
    checkbox.disabled = true;
  }

  function enableCheckbox(checkbox) {
    if (!checkbox) return;
    if (checkbox.dataset.easifyDisabledByWidth === 'true' || checkbox.disabled) {
      checkbox.disabled = false;
      delete checkbox.dataset.easifyDisabledByWidth;
    }
  }

  function clearCheckboxSelection(checkbox, addOnsEl, sequence, attempt, done) {
    if (sequence !== visibilitySequence) return;

    if (!needsRealUncheck(checkbox, addOnsEl)) {
      disableCheckbox(checkbox);
      done();
      return;
    }

    performRealClick(checkbox);

    window.setTimeout(function () {
      if (sequence !== visibilitySequence) return;

      if (!needsRealUncheck(checkbox, addOnsEl)) {
        disableCheckbox(checkbox);
        done();
        return;
      }

      if (attempt < MAX_UNCHECK_ATTEMPTS) {
        clearCheckboxSelection(checkbox, addOnsEl, sequence, attempt + 1, done);
        return;
      }

      done();
    }, UNCHECK_VERIFY_MS);
  }

  function applyHiddenState(addOnsEl) {
    addOnsEl.classList.remove(VISIBLE_CLASS);
    addOnsEl.style.setProperty('display', 'none', 'important');
    addOnsEl.setAttribute('hidden', 'hidden');
    addOnsEl.setAttribute('aria-hidden', 'true');
  }

  function hideAddOnsAfterRealUncheck(addOnsEl, sequence) {
    var checkboxes = qsa('input[type="checkbox"]', addOnsEl);

    if (!checkboxes.length) {
      applyHiddenState(addOnsEl);
      delete addOnsEl.dataset.easifyUncheckPending;
      return;
    }

    var remaining = checkboxes.length;
    function completeOne() {
      remaining -= 1;
      if (remaining > 0 || sequence !== visibilitySequence) return;

      checkboxes.forEach(function (checkbox) {
        if (!needsRealUncheck(checkbox, addOnsEl)) {
          disableCheckbox(checkbox);
        }
      });

      delete addOnsEl.dataset.easifyUncheckPending;
    }

    checkboxes.forEach(function (checkbox) {
      enableCheckbox(checkbox);
      clearCheckboxSelection(checkbox, addOnsEl, sequence, 1, completeOne);
    });

    applyHiddenState(addOnsEl);
  }

  function setAddOnsVisible(show, addOnsEl) {
    if (!addOnsEl) return;

    var checkboxes = qsa('input[type="checkbox"]', addOnsEl);

    if (show) {
      visibilitySequence += 1;
      delete addOnsEl.dataset.easifyUncheckPending;
      checkboxes.forEach(enableCheckbox);
      addOnsEl.classList.add(VISIBLE_CLASS);
      addOnsEl.style.setProperty('display', 'revert', 'important');
      addOnsEl.removeAttribute('hidden');
      addOnsEl.removeAttribute('aria-hidden');
      return;
    }

    if (addOnsEl.dataset.easifyUncheckPending === 'true') {
      applyHiddenState(addOnsEl);
      return;
    }

    var stillSelected = checkboxes.some(function (checkbox) {
      return needsRealUncheck(checkbox, addOnsEl);
    });

    if (!stillSelected) {
      checkboxes.forEach(disableCheckbox);
      applyHiddenState(addOnsEl);
      return;
    }

    visibilitySequence += 1;
    var sequence = visibilitySequence;
    addOnsEl.dataset.easifyUncheckPending = 'true';
    hideAddOnsAfterRealUncheck(addOnsEl, sequence);
  }

  function updateAddOns() {
    var dimensionEl = getDimensionEl();
    var addOnsEl = getAddOnsEl();
    var widthInput = findWidthInput(dimensionEl);
    var width = getNumericValue(widthInput);

    setAddOnsVisible(width !== null && width >= WIDTH_MIN, addOnsEl);
  }

  function updateCmHints() {
    var dimensionEl = getDimensionEl();
    if (!dimensionEl) return;

    updateHint(findWidthInput(dimensionEl));
    updateHint(findHeightInput(dimensionEl));
  }

  function update() {
    updateAddOns();
    updateCmHints();
    updateDimensionPriceDisplay();
  }

  function scheduleUpdate() {
    update();
    window.setTimeout(update, 80);
    window.setTimeout(update, 300);
  }

  function bindInputListeners(widthInput, heightInput) {
    [widthInput, heightInput].forEach(function (input) {
      if (!input || boundInputs.has(input)) return;
      boundInputs.add(input);
      input.addEventListener('input', scheduleUpdate);
      input.addEventListener('change', scheduleUpdate);
    });
  }

  function isReady(dimensionEl, widthInput, heightInput, addOnsEl) {
    if (!dimensionEl || !widthInput || !heightInput || !addOnsEl) return false;
    return hintMap.has(widthInput) && hintMap.has(heightInput) && getDimensionPriceSuffix(dimensionEl);
  }

  function teardownBootstrap() {
    if (isBootstrapped) return;
    isBootstrapped = true;

    if (pollId !== null) {
      clearInterval(pollId);
      pollId = null;
    }

    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function bootstrap() {
    update();
    bootstrapAttempts += 1;

    var dimensionEl = getDimensionEl();
    var widthInput = findWidthInput(dimensionEl);
    var heightInput = findHeightInput(dimensionEl);
    var addOnsEl = getAddOnsEl();

    if (isReady(dimensionEl, widthInput, heightInput, addOnsEl)) {
      bindInputListeners(widthInput, heightInput);
      teardownBootstrap();
      return;
    }

    if (bootstrapAttempts >= MAX_BOOTSTRAP_ATTEMPTS) {
      bindInputListeners(widthInput, heightInput);
      teardownBootstrap();
    }
  }

  function init() {
    bootstrap();

    var root = getObserveRoot();
    observer = new MutationObserver(bootstrap);
    observer.observe(root, { childList: true, subtree: true });

    pollId = window.setInterval(bootstrap, 300);
    window.__easifyAddOnsDebug = update;
    window.__easifyDimensionCmDebug = updateCmHints;
    window.__easifyDimensionPriceDebug = updateDimensionPriceDisplay;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();